import { createApi } from '@reduxjs/toolkit/query/react';
import { getAPIBaseURL } from '../../../../utils/utils.mjs';
import { createBaseQuery } from '../../createBaseQuery.mjs';

"use strict";
const API_GROUP = "logsdrilldown.grafana.app";
const API_VERSION = "v1beta1";
const BASE_URL = getAPIBaseURL(API_GROUP, API_VERSION);
const api = createApi({
  reducerPath: "logsdrilldownAPIv1beta1",
  baseQuery: createBaseQuery({
    baseURL: BASE_URL
  }),
  endpoints: () => ({})
});

export { API_GROUP, API_VERSION, BASE_URL, api };
//# sourceMappingURL=baseAPI.mjs.map
